import { Paper, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

export const BatchNotSelected = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  return (
    <Paper
      sx={{
        p: theme.spacing(6),
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(4),
      }}
    >
      <Typography variant="h6">
        {formatMessage({ id: 'metrics.batchNotSelected.title' })}
      </Typography>
      <Typography variant="body1">
        {formatMessage({ id: 'metrics.batchNotSelected.description' })}
      </Typography>
    </Paper>
  );
};
